import Vue from 'vue'
import Router from 'vue-router'
import { inheritSessionForPopup, isLoggedIn, setCurrentUser, isAdmin, isLabAnalyst, resolveDefaultHomeRoute } from '@/utils/user'
import { canAccessMenuPath } from '@/utils/ivanMenuAuth'
import { IVAN_MENU_GROUPS } from '@/config/ivanMenus'
import Login from '@/views/Login'
import Layout from '@/views/Layout'
import Dashboard from '@/views/Dashboard'
import TodoBox from '@/views/ivan/TodoBox'
import TodoCalendar from '@/views/ivan/TodoCalendar'
import PickBatchArrange from '@/views/ivan/PickBatchArrange'
import PickBatchByContract from '@/views/ivan/PickBatchByContract'
import PickCalendar from '@/views/ivan/PickCalendar'
import DoingPick from '@/views/ivan/DoingPick'
import PickInput from '@/views/ivan/PickInput'
import TaskTrack from '@/views/ivan/TaskTrack'
import IvanStub from '@/views/ivan/IvanStub'
import ProjectList from '@/views/ProjectList'
import TaskList from '@/views/TaskList'
import FormFill from '@/views/FormFill'
import ReportList from '@/views/ReportList'
import PhotoManage from '@/views/PhotoManage'
import UserProfile from '@/views/UserProfile'
import SoilEntry from '@/views/SoilEntry'
import SoilDocxEntry from '@/views/SoilDocxEntry'
import FormDocxView from '@/views/FormDocxView'
import TemplateCompare from '@/views/TemplateCompare'
import InstrumentLedger from '@/views/InstrumentLedger'
import CmaScope from '@/views/CmaScope'
import OfficeDirectorHome from '@/views/home/OfficeDirectorHome'
import FieldDirectorHome from '@/views/home/FieldDirectorHome'
import SampleHandover from '@/views/SampleHandover'
import ArrangeAnalyser from '@/views/ArrangeAnalyser'
import LabQueue from '@/views/LabQueue'
import UserManage from '@/views/UserManage'
import DeptManage from '@/views/ivan/DeptManage'
import RoleManage from '@/views/ivan/RoleManage'
import InspectTypeSetting from '@/views/ivan/InspectTypeSetting'
import ItemFactorSetting from '@/views/ivan/ItemFactorSetting'
import ProjectTypeSetting from '@/views/ivan/ProjectTypeSetting'
import MethodAccordSetting from '@/views/ivan/MethodAccordSetting'
import AnalyseParamSetting from '@/views/ivan/AnalyseParamSetting'
import MonitorFeeSetting from '@/views/ivan/MonitorFeeSetting'
import ReportTplSetting from '@/views/ivan/ReportTplSetting'
import SysDicSetting from '@/views/ivan/SysDicSetting'
import LoginLogView from '@/views/ivan/LoginLogView'
import EntrustFlow from '@/views/EntrustFlow'
import RoutineEntrustFlow from '@/views/RoutineEntrustFlow'
import SelfSendEntrustFlow from '@/views/SelfSendEntrustFlow'
import EntrustAudit from '@/views/EntrustAudit'
import RoutinePickPlan from '@/views/RoutinePickPlan'
import RoutineTaskAdmin from '@/views/RoutineTaskAdmin'
import RoutineQuery from '@/views/RoutineQuery'
import ContractList from '@/views/ContractList'
import ContractEditor from '@/views/ContractEditor'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (err && (err.name === 'NavigationDuplicated' || /Redirected/.test(String(err.message || '')))) return err
    throw err
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (err && (err.name === 'NavigationDuplicated' || /Redirected/.test(String(err.message || '')))) return err
    throw err
  })
}

const stub = (title, hint) => ({
  component: IvanStub,
  meta: { title, hint: hint || '' }
})

const router = new Router({
  routes: [
    { path: '/login', component: Login },
    { path: '/soil/docx-entry', component: SoilDocxEntry, meta: { title: 'Word 原表录入' } },
    { path: '/soil/template-compare', component: TemplateCompare, meta: { title: '模板对比' } },
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', redirect: '/home' },
        { path: 'dashboard', redirect: '/home' },
        { path: 'home', name: 'HomePortal', component: Dashboard, meta: { title: '首页' } },
        { path: 'home/office', name: 'OfficeDirectorHome', component: OfficeDirectorHome, meta: { title: '综合部工作台' } },
        { path: 'home/field', name: 'FieldDirectorHome', component: FieldDirectorHome, meta: { title: '现场部工作台' } },
        { path: 'todo', name: 'TodoBox', component: TodoBox, meta: { title: '待我处理的', fillHeight: true } },
        { path: 'todo-calendar', name: 'TodoCalendar', component: TodoCalendar, meta: { title: '待办日历', fillHeight: true } },
        { path: 'pick/batch-arrange', name: 'PickBatchArrange', component: PickBatchArrange, meta: { title: '批量采样安排', fillHeight: true } },
        { path: 'pick/batch-contract', name: 'PickBatchByContract', component: PickBatchByContract, meta: { title: '批量现场采样(按合同)', fillHeight: true } },
        { path: 'pick/batch-task', name: 'PickBatchByTask', ...stub('批量现场采样(按任务)', '功能未开放，请使用「批量现场采样(按合同)」') },
        { path: 'pick/calendar', name: 'PickCalendar', component: PickCalendar, meta: { title: '采样日历', fillHeight: true } },
        { path: 'pick/doing', name: 'DoingPick', component: DoingPick, meta: { title: '采样管理', fillHeight: true } },
        { path: 'pick/input', name: 'PickInput', component: PickInput, meta: { title: '采样信息', fillHeight: true } },
        { path: 'task-track', name: 'TaskTrack', component: TaskTrack, meta: { title: '任务监控', fillHeight: true } },

        { path: 'entrust/new', name: 'EntrustFlow', component: EntrustFlow, meta: { title: '委托发起' } },
        { path: 'entrust/:xmbh', name: 'EntrustFlow', component: EntrustFlow, meta: { title: '委托发起' } },
        { path: 'routine/new', name: 'RoutineEntrustFlow', component: RoutineEntrustFlow, meta: { title: '周期任务执行' } },
        { path: 'routine/audit/:xmbh', name: 'EntrustAudit', component: EntrustAudit, meta: { title: '委托审核' } },
        { path: 'routine/plan/:xmbh', name: 'RoutinePickPlan', component: RoutinePickPlan, meta: { title: '周期任务安排' } },
        { path: 'routine/:xmbh', name: 'RoutineEntrustFlow', component: RoutineEntrustFlow, meta: { title: '周期任务执行' } },
        { path: 'self-send/new', name: 'SelfSendEntrustFlow', component: SelfSendEntrustFlow, meta: { title: '来样检测' } },
        { path: 'self-send/:xmbh', name: 'SelfSendEntrustFlow', component: SelfSendEntrustFlow, meta: { title: '来样检测' } },

        { path: 'routine-admin', component: RoutineTaskAdmin, meta: { title: '周期任务管理' } },
        { path: 'routine-plans', component: RoutineQuery, meta: { title: '周期任务安排', defaultTab: 'pending' } },
        { path: 'routine-query', component: RoutineQuery, meta: { title: '周期任务查询' } },
        { path: 'projects', redirect: '/task-track' },
        { path: 'tasks', redirect: '/pick/doing' },
        { path: 'dispatch-list', component: TaskList, meta: { title: '任务派遣单' } },
        { path: 'project-list', component: ProjectList, meta: { title: '项目管理' } },
        { path: 'forms', component: FormFill, meta: { title: '表单查看' } },
        { path: 'forms/docx', component: FormDocxView, meta: { title: '表单查看' } },
        { path: 'photos', component: PhotoManage, meta: { title: '项目照片' } },
        { path: 'soil', component: SoilEntry, meta: { title: '分析管理', lab: true } },
        { path: 'project/:xmbh', redirect: to => ({ path: '/task-track', query: { xmbh: to.params.xmbh || '' } }) },
        { path: 'soil/project/:xmbh', redirect: to => ({ path: '/task-track', query: { xmbh: to.params.xmbh || '' } }) },
        { path: 'soil/handover', component: SampleHandover, meta: { title: '样品管理', fillHeight: true } },
        { path: 'soil/sample-manage', redirect: '/soil/handover' },
        { path: 'soil/dispatch-lab', redirect: '/soil/handover' },
        { path: 'soil/arrange', component: ArrangeAnalyser, meta: { title: '检测任务安排', fillHeight: true } },
        { path: 'soil/lab-queue', component: LabQueue, meta: { title: '理化任务队列', lab: true, fillHeight: true } },
        { path: 'instruments', component: InstrumentLedger, meta: { title: '仪器管理' } },
        { path: 'cma-scope', component: CmaScope, meta: { title: 'CMA能力范围' } },
        { path: 'reports', component: ReportList, meta: { title: '报告管理' } },
        { path: 'contracts', component: ContractList, meta: { title: '合同管理' } },
        { path: 'contracts/:id', component: ContractEditor, meta: { title: '编辑合同' } },
        { path: 'admin/users', component: UserManage, meta: { title: '用户管理', admin: true } },
        { path: 'admin/department', component: DeptManage, meta: { title: '部门管理', admin: true } },
        { path: 'admin/role', component: RoleManage, meta: { title: '角色权限', admin: true } },
        { path: 'setting/inspect-type', component: InspectTypeSetting, meta: { title: '项目类型', admin: true } },
        { path: 'setting/item-factor', component: ItemFactorSetting, meta: { title: '项目因子', admin: true } },
        { path: 'setting/project-type', component: ProjectTypeSetting, meta: { title: '监测类别', admin: true } },
        { path: 'setting/method-accord', component: MethodAccordSetting, meta: { title: '方法依据', admin: true } },
        { path: 'setting/analyse-param', component: AnalyseParamSetting, meta: { title: '分析参数', admin: true } },
        { path: 'setting/monitor-fee', component: MonitorFeeSetting, meta: { title: '监测费用', admin: true } },
        { path: 'setting/report-tpl', component: ReportTplSetting, meta: { title: '报告模板', admin: true } },
        { path: 'setting/sys-dic', component: SysDicSetting, meta: { title: '系统字典', admin: true } },
        { path: 'admin/login-log', component: LoginLogView, meta: { title: '登陆日志', admin: true } },
        { path: 'profile', component: UserProfile, meta: { title: '个人中心' } },

        { path: 'stub/todo-calendar', redirect: '/todo-calendar' },
        { path: 'stub/pick-batch-pc', redirect: '/pick/batch-arrange' },
        { path: 'stub/pick-batch-contract', redirect: '/pick/batch-contract' },
        { path: 'stub/pick-batch-task', ...stub('批量现场采样(按任务)', '功能未开放，请使用「批量现场采样(按合同)」') },
        { path: 'stub/pick-calendar', redirect: '/pick/calendar' },
        { path: 'stub/pick-history', ...stub('采样历史查询') },
        { path: 'stub/lab-history', ...stub('分析历史查询') },
        { path: 'stub/business-admin', ...stub('订单管理') },
        { path: 'stub/income-history', ...stub('回款历史') },
        { path: 'stub/invoice-history', ...stub('开票历史') },
        { path: 'stub/enterprise', ...stub('企业管理', '请在委托发起中通过企业选择器管理企业与点位') },
        { path: 'stub/std-solution', ...stub('标准物质管理') },
        { path: 'stub/inspect-type', redirect: '/setting/inspect-type' },
        { path: 'stub/item-factor', redirect: '/setting/item-factor' },
        { path: 'stub/project-type', redirect: '/setting/project-type' },
        { path: 'stub/method-accord', redirect: '/setting/method-accord' },
        { path: 'stub/analyse-param', redirect: '/setting/analyse-param' },
        { path: 'stub/monitor-fee', redirect: '/setting/monitor-fee' },
        { path: 'stub/report-tpl', redirect: '/setting/report-tpl' },
        { path: 'stub/sys-dic', redirect: '/setting/sys-dic' },
        { path: 'stub/department', redirect: '/admin/department' },
        { path: 'stub/role', redirect: '/admin/role' },
        { path: 'stub/data-import', ...stub('数据导入') },
        { path: 'stub/super-config', ...stub('超管配置') },
        { path: 'stub/wf-setting', ...stub('流程设置') },
        { path: 'stub/mini-wf', ...stub('模块配置') },
        { path: 'stub/login-log', redirect: '/admin/login-log' }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/login') {
    inheritSessionForPopup()
  }
  if (to.path === '/login') {
    if (isLoggedIn()) {
      next(resolveDefaultHomeRoute())
      return
    }
    next()
    return
  }
  if (!isLoggedIn() && to.path === '/soil/docx-entry' && to.query.yhid) {
    setCurrentUser({
      id: String(to.query.yhid),
      xm: String(to.query.yhmc || '')
    })
  }
  if (!isLoggedIn() && to.path === '/soil/template-compare') {
    setCurrentUser({ id: '0', xm: '模板对比' })
  }
  if (!isLoggedIn()) {
    next('/login')
    return
  }
  // 原 meta.admin：超管专属页；Ivan 角色若已授权（如技术负责人→方法依据）则放行
  const fallbackHome = resolveDefaultHomeRoute()
  if (to.matched.some(r => r.meta && r.meta.admin) && !isAdmin() && !canAccessMenuPath(to.path, IVAN_MENU_GROUPS)) {
    next(fallbackHome)
    return
  }
  if (to.matched.some(r => r.meta && r.meta.lab) && !isLabAnalyst()) {
    next(fallbackHome)
    return
  }
  if (!canAccessMenuPath(to.path, IVAN_MENU_GROUPS)) {
    next(fallbackHome)
    return
  }
  if (to.path === '/home' || to.path === '/home/') {
    const target = resolveDefaultHomeRoute()
    if (target !== '/home') {
      next(target)
      return
    }
  }
  next()
})

export default router
